import styled from 'styled-components';

const Content = styled.div`
  width: 100%;
  flex: 1;
  transform: translateY(-1px);
`;

export default Content;
